module.exports = __webpack_public_path__ + "img/SI5349907.67f7b703.jpeg";